import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export function PermissionsNotification({ c }) {
  const { t } = useTranslation('account');

  return (
    <Fragment>
      <p>
        {t('notifications.permissions.info', {
          name: c.organization || c.practitioner || t('notifications.permissions.someone')
        })}
      </p>
      <p className="prompt">{t('notifications.permissions.prompt')}</p>
    </Fragment>
  );
};

export default PermissionsNotification;
